export enum PropertyType {
  "Single Family",
  "Multi Family",
  "Condo/Town Home",
  "Mobile Home",
}
